// @flow
import * as React from 'react';
import { Button, Form, Input, Modal, Space, Table } from 'antd';
import administracionProvider from '../../../../services/administracionProvider';
import { PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import Moment from 'react-moment';
import { ModalBitacora } from './modal';

const columns = [
  {
    title: 'Observación',
    dataIndex: 'observaciones',
    width: '20%'
  },
  {
    title: 'Estado',
    dataIndex: 'estado',
    width: '20%'
  },
  {
    title: 'Fecha Registro',
    dataIndex: 'fechaReg',
    sorter: true,
    render: (text, row, index) => {
      return <Moment format={'LLL'}>{text}</Moment>;
    }
  }
];

export class Bitacora extends React.Component {
  state = {
    selectedRowKeys: [],
    data: [],
    pagination: {
      current: 1,
      pageSize: 10
    },
    loading: false,
    mostrarAgregarBitacora: false,
    loadingAdd: false
  };

  componentDidMount() {
    const { pagination } = this.state;
    this.fetch({ pagination });
  }

  handleTableChange = (pagination, filters, sorter) => {
    this.fetch({
      sortField: sorter.field,
      sortOrder: sorter.order,
      pagination,
      ...filters
    });
  };

  fetch = (params: any = {}) => {
    this.setState({ loading: true });
    administracionProvider.obtenerBitacora(0, params).then((data: any) => {
      this.setState({
        loading: false,
        data: data.result.data,
        pagination: {
          ...params.pagination,
          total: data.result.totalRecords
        }
      });
    });
  };

  refrescar = () => {
    this.setState({ loading: true });
    this.fetch({
      pagination: {
        current: 1,
        pageSize: 10
      }
    });
    this.setState({ loading: false });
  };

  onSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };

  render() {
    const { data, pagination, loading, loadingAdd, selectedRowKeys, mostrarAgregarBitacora } =
      this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange
    };
    const hasSelected = selectedRowKeys.length === 1;
    const param = {
      id: selectedRowKeys[0],
      visible: mostrarAgregarBitacora
    };
    return (
      <>
        <Space style={{ marginBottom: 16 }}>
          <Button
            type={'primary'}
            icon={<ReloadOutlined />}
            loading={loading}
            shape={'circle'}
            onClick={this.refrescar}
          ></Button>
          <Button
            type={'primary'}
            icon={<PlusOutlined />}
            onClick={() => this.setState({ mostrarAgregarBitacora: true })}
          >
            Agregar bitacora
          </Button>
          <Button
            type={'primary'}
            onClick={() => this.setState({ mostrarAgregarBitacora: true })}
            disabled={!hasSelected}
            loading={loading}
          >
            Editar
          </Button>
        </Space>
        <ModalBitacora {...param} />
        <Table
          rowSelection={rowSelection}
          columns={columns}
          rowKey={(record) => record.key}
          dataSource={data}
          pagination={pagination}
          loading={loading}
          onChange={this.handleTableChange}
        />
      </>
    );
  }
}
